










import Vue from 'vue'

export default Vue.extend({
  name: 'InfoGuideDialog',
  props: {
    infoGuideDialogOpened: Boolean
  },
  data () {
    return {
      modalActive: false
    }
  },
  methods: {
    close () {
      this.$emit('closeInfoGuideDialog')
    }
  },
  watch: {
    infoGuideDialogOpened (val) {
      this.modalActive = val
    }
  }
})
